import { render, staticRenderFns } from "./AIChatWindow.vue?vue&type=template&id=5007f7f8&scoped=true"
import script from "./AIChatWindow.vue?vue&type=script&lang=js"
export * from "./AIChatWindow.vue?vue&type=script&lang=js"
import style0 from "./AIChatWindow.vue?vue&type=style&index=0&id=5007f7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007f7f8",
  null
  
)

export default component.exports